import Vue from "vue";

import { userClient, rvkadminClient } from "@/compose";

function initial() {
  return {
    branches: null,
    users: {},
    customers: {}
  };
}

export default {
  state: initial(),
  getters: {
    branches: state => state.branches,
    users: state => branchName => state.users[branchName],
    customers$1: state => branchName => state.customers[branchName]
  },
  mutations: {
    reset(state) {
      Object.assign(state, initial());
    },

    updateBranches(state, branches) {
      state.branches = branches;
    },
    updateUsers(state, { branchName, users }) {
      Vue.set(state.users, branchName, users);
    },
    updateCustomers$1(state, { branchName, customers }) {
      Vue.set(state.customers, branchName, customers);
    },

    addNewUser(state, { branchName, user }) {
      Vue.set(state.users, branchName, [...state.users[branchName], user]);
    },
    updateUser(state, { branchName, loginName, userData }) {
      for (let user of state.users[branchName]) {
        if (user.loginName === loginName) {
          Object.assign(user, userData);
          break;
        }
      }
    }
  },
  actions: {
    loadBranches(context) {
      rvkadminClient.allLocations().subscribe(response =>
        context.commit(
          "updateBranches",
          response.map(branch => ({
            name: branch.locationName
          }))
        )
      );
    },
    loadUsers(context, branch) {
      rvkadminClient
        .getAllRhenusWorkerByLocation(branch.name)
        .subscribe(response =>
          context.commit("updateUsers", {
            branchName: branch.name,
            users: response.map(user => ({
              loginName: user.loginName,
              firstName: user.employeeFirstName,
              lastName: user.employeeLastName,
              email: user.userEmail,
              active: user.active
            }))
          })
        );
    },
    loadCustomers$1(context, branch) {
      rvkadminClient
        .getCustomerNamesBylocationName(branch.name)
        .subscribe(response =>
          context.commit("updateCustomers$1", {
            branchName: branch.name,
            customers: response.map(customer => ({
              name: customer.customerName
            }))
          })
        );
    },

    createNewUser(context, { branch, user }) {
      return rvkadminClient
        .userToLocation({
          locationName: branch.name,
          userFirstName: user.firstName,
          userLastName: user.lastName,
          userEmail: user.email
        })
        .toPromise()
        .then(response => ({
          loginName: response.loginName,
          password: response.password
        }))
        .then(generatedData => {
          context.commit("addNewUser", {
            branchName: branch.name,
            user: {
              loginName: user.loginName,
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email,
              active: true,
              ...generatedData
            }
          });
          return generatedData;
        });
    },
    saveUser(context, { branch, user }) {
      return rvkadminClient
        .updateUserData({
          loginName: user.loginName,
          userFirstName: user.firstName,
          userLastName: user.lastName,
          userEmail: user.email
        })
        .toPromise()
        .then(() =>
          context.commit("updateUser", {
            branchName: branch.name,
            loginName: user.loginName,
            userData: {
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email
            }
          })
        );
    },
    requestPassword(context, { branchName, loginName }) {
      return userClient
        .generateNewPasswordUsingPUT(loginName)
        .toPromise()
        .then(response => response.password)
        .then(password =>
          context.commit("updateUser", {
            branchName,
            loginName,
            userData: { password }
          })
        );
    },
    enableUser(context, { branchName, loginName }) {
      return userClient
        .enableUserUsingGET(loginName)
        .toPromise()
        .then(password =>
          context.commit("updateUser", {
            branchName,
            loginName,
            userData: {
              active: true
            }
          })
        );
    },
    disableUser(context, { branchName, loginName }) {
      return userClient
        .disableUserUsingGET(loginName)
        .toPromise()
        .then(password =>
          context.commit("updateUser", {
            branchName,
            loginName,
            userData: {
              active: false
            }
          })
        );
    }
  }
};
